// Sursă unică pentru URL-uri folosite atât din build config (Node/CommonJS)
// cât și din codul aplicației (Vue/webpack) — schimbă aici dacă se mută backend-ul.
module.exports = {
  API_BASE_URL: 'https://photobooth.brk-dev.ro',
}
